import { render } from "./ButtonStyleEditor.vue?vue&type=template&id=8a351806"
import script from "./ButtonStyleEditor.vue?vue&type=script&lang=js"
export * from "./ButtonStyleEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItemLabel,QSlider});
